
export enum EventStepState
{
    Preparing = "Preparing",
    Incoming = "Incoming",    
    Executing = "Executing",
    Executed = "Executed",
    Canceled = "Canceled",
    Omitted = "Omitted"
}
